module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0i5ZyW5bGkXzEiIGRhdGEtbmFtZT0i5ZyW5bGkIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDgxMyA4MTMiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojYzdkY2UyO30uY2xzLTJ7ZmlsbDojNTQ2NTZlO30uY2xzLTN7ZmlsbDojNjk3ZTg3O308L3N0eWxlPjwvZGVmcz48dGl0bGU+RmxpY2tyPC90aXRsZT48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjQwNi41IiBjeT0iNDA2LjUiIHI9IjQwNi41Ii8+PGNpcmNsZSBjbGFzcz0iY2xzLTIiIGN4PSIyNDQuNSIgY3k9IjQwNi41IiByPSIxMjEuNSIvPjxjaXJjbGUgY2xhc3M9ImNscy0zIiBjeD0iNTY2LjUiIGN5PSI0MDYuNSIgcj0iMTIxLjUiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flickr-icon.svg
// module id = mpDD
// module chunks = 1